import React from 'react';

const LoadingSpinner = ({ message = "Yükleniyor..." }) => {
  return (
    <div className="loading-spinner" style={{
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(20px)',
      borderRadius: '20px',
      padding: '3rem',
      margin: '20px'
    }}>
      <div className="text-center">
        <div 
          className="spinner-border" 
          role="status" 
          style={{
            width: '4rem', 
            height: '4rem',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite, pulse 2s ease-in-out infinite'
          }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-4 fw-bold" style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          fontSize: '1.2rem'
        }}>
          {message}
        </p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
